function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVWolontariat1 = function SvgVWolontariat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.12 50.31-8.36-4-33.66 70.3-.09.19-34.99-69.85-21.46 10.76 42.94 85.7.09.16a15.26 15.26 0 0 0 13.6 8.26h.15c5.59-.06 10.62-3.08 13.29-7.96l.3-.57 36.5-76.23 4.98-10.4z",
    style: {
      fill: "#091f2c"
    }
  }));
};
export default SvgVWolontariat1;